"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _pureReactCarousel = require("pure-react-carousel");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _FiberManualRecord = _interopRequireDefault(require("@material-ui/icons/FiberManualRecord"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var SlideshowStepper = function SlideshowStepper() {
  var carouselContext = _react["default"].useContext(_pureReactCarousel.CarouselContext);

  var subscribe = carouselContext.subscribe,
      unsubscribe = carouselContext.unsubscribe;

  var getActiveStep = function getActiveStep() {
    return (0, _lodash["default"])(carouselContext, 'state.currentSlide', 0);
  };

  var getSteps = function getSteps() {
    return (0, _lodash["default"])(carouselContext, 'state.totalSlides', 0) - (0, _lodash["default"])(carouselContext, 'state.visibleSlides', 0) + 1;
  };

  var _React$useState = _react["default"].useState({
    activeStep: getActiveStep(),
    steps: getSteps()
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      _React$useState2$ = _React$useState2[0],
      activeStep = _React$useState2$.activeStep,
      steps = _React$useState2$.steps,
      setCurrent = _React$useState2[1];

  _react["default"].useEffect(function () {
    function onChange() {
      setCurrent({
        activeStep: getActiveStep(),
        steps: getSteps()
      });
    }

    subscribe(onChange);
    return function () {
      return unsubscribe(onChange);
    };
  }, [carouselContext]);

  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    component: "ol",
    display: "flex",
    justifyContent: "center",
    textAlign: "center",
    m: 0,
    p: 0,
    style: {
      listStyle: 'none'
    }
  }, Array.from({
    length: steps
  }).map(function (_, index) {
    return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
      color: index === activeStep ? 'primary.main' : undefined,
      component: "li",
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
      color: "inherit",
      "aria-label": "Jump to slide ".concat(index),
      tabIndex: 0,
      onClick: function onClick() {
        return carouselContext.setStoreState({
          currentSlide: index
        });
      },
      size: "small"
    }, /*#__PURE__*/_react["default"].createElement(_FiberManualRecord["default"], {
      style: {
        height: 14,
        width: 14
      }
    })));
  }));
};

var _default = SlideshowStepper;
exports["default"] = _default;